export default __webpack_public_path__ + "static/media/central-fricanrepublic.64e2f397.png";